import { WeaTools } from 'ecCom';

export const newUrl = '/api/cube/custompage'



export const getCustomPageViewData = (params) => {
    return WeaTools.callApi(`${newUrl}/getCustomPageViewData`, "get", params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/customPage.ts